import { z } from '../utils/zod-extend'
import { stringArrayParamSchema } from './http-param.type'

export const sortDirections = ['asc', 'desc'] as const

export const sortingParamSchema = z.object({
  sortFields: stringArrayParamSchema.optional(),
  sortDirections: stringArrayParamSchema.optional().pipe(z.enum(sortDirections).array().optional()),
})
export type SortingQuery = z.infer<typeof sortingParamSchema>

export const sortingOptionsSchema = z.object({
  sorts: sortingParamSchema.transform((v) => {
    return {
      fields: v.sortFields,
      directions: v.sortDirections,
    }
  }).optional(),
})
export type SortOptions = z.infer<typeof sortingOptionsSchema>
